import ContentLoader from 'react-content-loader';
import { openPostViewerEventSources } from '../PostsViewer/types/openPostViewerEventSources';
import { Post } from '../PostsViewer/types/Post';
import { PostImageGridItem } from './components/PostImageGridItem';

interface IProps {
  posts: Post[];
  openPostViewer: (postId?: string, eventSource?: openPostViewerEventSources) => Promise<void>;
  isLoading: boolean;
}

export const PostImageGrid = ({ posts, openPostViewer, isLoading }: IProps) => {
  if (isLoading) {
    return (
      <div className="size-full">
        <ContentLoader
          uniqueKey={`postimage-grid-loader`}
          id={`postimage-grid-loader`}
          className="flex h-[350px] w-full items-center justify-center"
        >
          <rect x="0" y="0" width="100%" height="100%" />
        </ContentLoader>
      </div>
    );
  }
  return (
    <div className="grid grid-flow-row-dense grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
      {posts.map(post => (
        <PostImageGridItem openPostViewer={openPostViewer} key={post._id} post={post} />
      ))}
    </div>
  );
};
